module.exports = __webpack_public_path__ + "static/img/style-home-btn.0fd1902c.png";